import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Endereco antigo do kanban do evento (`/eventos/kanban?evento=ID`): o quadro agora e' a aba Kanban da pagina do
 * evento (`/eventos/:eventoId?aba=kanban`). A rota fica pelos links e favoritos antigos e porque a tela
 * `eventos-kanban` do RBAC e' o que libera essa aba.
 */
export default function EventosKanbanPage() {
  const [searchParams] = useSearchParams();
  const evento = searchParams.get('evento');
  return <Navigate to={evento ? `/eventos/${evento}?aba=kanban` : '/eventos'} replace />;
}
